// Authors tab: author (+ display name), translator, illustrator, narrator pickers.
import React from "react"
import { Field, TextInput } from "../../../AdminShared/ui"
import { LanguageTag } from "aldoo-ra/Admin/Store/Products/EditingLanguage"
import useProductEditorTexts from "aldoo-ra/CMSModels/StoreProduct/useProductEditorTexts"

// a label of a field that changes with the dialog's language
const localized = (label) => (
  <span className="inline-flex items-center gap-1.5">
    {label}
    <LanguageTag />
  </span>
)
import SelectCreator from "../shared/SelectCreator"
import HelpHint from "aldoo-ra/HelpCenter/InPlaceHelp"

export default function AuthorsTab({ editor, shouldShowField, isProductEditor }) {
  const { read, set, language } = editor
  const t = useProductEditorTexts()
  return (
    <div className="flex flex-col gap-2">
      <div className="grid md:grid-cols-2 gap-4 mb-2">
        {shouldShowField("author") && (
          <SelectCreator role={["author", "company"]} label={t`Author`} language={language} value={read("author", true)} setValue={(v) => set("author", v, true)} disabled={!isProductEditor} data-testid="select-author" />
        )}
        {shouldShowField("author_display_name") && (
          <Field label={<span className="inline-flex items-center gap-1.5">{localized(t`Author Display Name (optional)`)}<HelpHint helpKey="vendor.product#authors" /></span>}>
            <TextInput value={editor.readOwn("author_display_name") ?? ""} placeholder={read("author_display_name") || ""} onChange={(v) => set("author_display_name", v)} disabled={!isProductEditor} data-testid="field-author-display-name" />
          </Field>
        )}
      </div>
      {shouldShowField("translator") && <SelectCreator role="translator" label={t`Translator`} language={language} value={read("translator", true)} setValue={(v) => set("translator", v, true)} disabled={!isProductEditor} data-testid="select-translator" />}
      {shouldShowField("illustrator") && <SelectCreator role="illustrator" label={t`Illustrator`} language={language} value={read("illustrator", true)} setValue={(v) => set("illustrator", v, true)} disabled={!isProductEditor} data-testid="select-illustrator" />}
      {shouldShowField("narrator") && <SelectCreator role="narrator" label={t`Narrator`} language={language} value={read("narrator", true)} setValue={(v) => set("narrator", v, true)} disabled={!isProductEditor} data-testid="select-narrator" />}
    </div>
  )
}
